export default __webpack_public_path__ + "static/demo-7ce680523266998c20b99bcd29e1bc51.mp4";